import POST_COMPONENT_TYPE from '../postComponentType';
import IronCheck from '../../../assets/images/iron-check-hero-section.png';
import IronTrackingImage from '../../../assets/images/iron-tracking.png';
import { IconType } from '../../../components/BannerWithList';

const ironCheckData = {
  key: 'iron-check',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.iron-check.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: IronCheck,
      text: 'learnMoreContent.iron-check.banner.text'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.iron-check.riskGroups.title',
      iconType: IconType.WARNING,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem3',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem4',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem5',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem6',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.riskGroups.listItem7',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.iron-check.whatToCheck.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.iron-check.whatToCheck.listItem1',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.iron-check.frequency.title',
      description: {
        text: 'learnMoreContent.iron-check.frequency.description',
        type: 'text'
      }
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithListAndProductCard,
      title: 'learnMoreContent.iron-check.howToCheck.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.iron-check.howToCheck.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.howToCheck.listItem2',
              type: 'text'
            }
          ]
        }
      ],
      product: {
        name:
          'learnMoreContent.iron-check.howToCheck.product.ironTracking.name',
        description:
          'learnMoreContent.iron-check.howToCheck.product.ironTracking.description',
        type: 'ironTracking',
        price: 'CHF 79',
        tags:
          'learnMoreContent.iron-check.howToCheck.product.ironTracking.tags',
        link:
          'https://yourself.health/products/iron-test-from-home-ferritin-crp?utm_source=yourself.health&utm_medium=portal&utm_campaign=check-up-planner&utm_content=iron-page',
        image: IronTrackingImage,
        addToCartUrl:
          'https://hy-demo.myshopify.com/cart/39364123787350:1?storefront=true&utm_source=yourself.health&utm_medium=portal&utm_campaign=check-up-planner&utm_content=iron-page'
      }
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.iron-check.preventiveMeasures.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.iron-check.preventiveMeasures.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.preventiveMeasures.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.iron-check.preventiveMeasures.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    }
  ]
};

export default ironCheckData;